import { passwordReset } from "@api/auth/passwordReset/path";
import { signIn } from "@api/auth/signIn/path";
import { signUpRequest } from "@api/auth/signUpRequest/path";
import { signUpToken } from "@api/auth/signUpToken/path";

export const auth = {
  passwordReset,
  signIn,
  signUpRequest,
  signUpToken,
};
